import { FormFieldsData } from 'framework/form';
import { STATUS_CHANGE_RULES } from 'domain/shared/candidate';

export const isStatusChangeCommentRequired = (values: FormFieldsData): boolean =>
  STATUS_CHANGE_RULES.some(({ currentFlag, initialFlag }) => values[currentFlag] && !values[initialFlag]);

export const isTrackedStatusSelected = (values: FormFieldsData): boolean =>
  STATUS_CHANGE_RULES.some(({ currentFlag }) => values[currentFlag]);

export const isStatusChangeCommentFilled = (values: FormFieldsData): boolean => !!values.statusChangeComment?.trim();

export const getChangedCandidateStatuses = (values: FormFieldsData): string[] =>
  STATUS_CHANGE_RULES.filter(
    ({ currentFlag, initialFlag }) => values[currentFlag] === true && values[initialFlag] === false,
  ).map(({ label }) => label);

export const getStatusChangeStateAfterSave = (values: FormFieldsData): FormFieldsData => ({
  statusChangeComment: '',
  ...Object.fromEntries(
    STATUS_CHANGE_RULES.map(({ currentFlag, initialFlag }) => [initialFlag, !!values[currentFlag]]),
  ),
});

export const buildStatusChangeTimelineNote = (statuses: string[], comment: string): string =>
  `Status changed to: ${statuses.join(', ')}. Reason: ${comment}`;
